module.exports = __webpack_public_path__ + "img/result_wine_d.6e2630ac.png";